import React, { useState } from "react";

const Project = () => {
  const [open, setOpen] = useState(false);
  const [project, setProject] = useState("");
  const [program, setProgram] = useState("");
  const [savedData, setSavedData] = useState(null);

  const programs = {
    "Shriram Finance": [
      "One Day Refresher Program",
      "Pre Licensing LMV Training Program",
      "Pre Licensing HMV Program",
    ],
    Mahindra: ["E Rickshaw Training Program"],
    Linde: [
      "One Day Refresher Program",
      "Hazardous (Hydrogen Tanker) Training Program",
    ],
  };

  const handleSave = () => {
    setSavedData({ project, program });
    setOpen(false);
  };

  return (
    <div className="p-6">
      <button
        onClick={() => setOpen(true)}
        className="px-4 py-2 bg-[#2BB5CE] text-white rounded hover:bg-[#219db3]"
      >
        Create Project
      </button>

      {/* Dialog */}
      {open && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50">
          <div className="bg-white p-6 rounded w-96 shadow-lg">

            <h2 className="text-xl font-semibold mb-4">Create Project</h2>
            <label className="font-medium">Select Project</label>
            <select
              value={project}
              onChange={(e) => {
                setProject(e.target.value);
                setProgram("");
              }}
              className="w-full border rounded px-3 py-2 mt-1 mb-4"
            >
              <option>Select project</option>
              <option value="Shriram Finance">Shriram Finance</option>
              <option value="Mahindra">Mahindra</option>
              <option value="Linde">Linde</option>
            </select>

            {/* Select Program */}
            {project && (
              <>
                <label className="font-medium">Select Program</label>
                <select
                  value={program}
                  onChange={(e) => setProgram(e.target.value)}
                  className="w-full border rounded px-3 py-2 mt-1 mb-4"
                >
                  <option>Select program</option>
                  {programs[project].map((item) => (
                    <option key={item}>{item}</option>
                  ))}
                </select>
              </>
            )}

            {/* Buttons */}
            <div className="flex justify-end gap-3 mt-3">
              <button
                onClick={() => setOpen(false)}
                className="px-4 py-2 border rounded"
              >
                Cancel
              </button>

              <button
                disabled={!project || !program}
                onClick={handleSave}
                className="px-4 py-2 bg-[#2BB5CE] text-white rounded disabled:opacity-50"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Saved Output */}
      {savedData && (
        <div className="mt-6 p-4 border rounded w-96 bg-gray-50">
          <h3 className="font-semibold text-lg">Saved Project</h3>
          <p><strong>Project:</strong> {savedData.project}</p>
          <p><strong>Program:</strong> {savedData.program}</p>
        </div>
      )}
    </div>
  );
};

export default Project;
